module.exports = __webpack_public_path__ + "static/media/physiotherapist-landing-icon.2fbf05c0.png";